module.exports = __webpack_public_path__ + "static/img/sebastian_logo_whitefilled_blueeyes.360abfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/sebastian_logo_whitefilled_blueeyes.png
// module id = DRq2
// module chunks = 0